<template>
    <div>
        <el-button type="primary" @click="addServerItem">添加时间段</el-button>
        <div class="a-flex-rfsc a-mt-12" v-for="(item,index) in form" :key="index">
            <el-select v-model="item.ruleType" placeholder="类型" class="input-size">
                <el-option
                    v-for="(ite,idx) in energyFeeTypeDic"
                    :key="idx"
                    :label="ite.label"
                    :value="ite.value">
                </el-option>
            </el-select>
            <!-- <el-select v-model="item.startTime" clearable placeholder="开始时间" class="input-size a-ml-10">
                <el-option
                    v-for="(ite,idx) in options"
                    :key="idx"
                    :label="ite"
                    :value="ite">
                </el-option>
            </el-select>
            <span class="form-text">至</span>
            <el-select v-model="item.endTime" clearable placeholder="结束时间" class="input-size">
                <el-option
                    v-for="(ite,idx) in options"
                    :key="idx"
                    :label="ite"
                    :value="ite">
                </el-option>
            </el-select> -->
            <el-time-picker
                v-model="item.startTime"
                value-format='HH:mm'
                format='HH:mm'
                placeholder="开始时间">
            </el-time-picker>
            <span class="form-text">至</span>
            <el-time-picker
                v-model="item.endTime"
                value-format='HH:mm'
                format='HH:mm'
                placeholder="结束时间">
            </el-time-picker>
            <!-- <le-time-range :minDate.sync="item.startTime" :maxDate.sync="item.endTime" /> -->
            <span class="form-text1">，费用</span>
            <el-input v-model="item.energyPrice" @input="item.energyPrice = util.checkMoney5(item.energyPrice)" style="min-width: 120px;width: 120px;" maxlength="50"  placeholder="请输入费用"></el-input>
            <span class="form-text">元</span>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" v-if="!showWaitPrice">
                <img src="../../../assets/icon/option-del-circle.png" @click="deleteServiceItem(index)" v-if="form.length>1" class="a-wh-16 a-mlr-12" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="添加" placement="top" v-if="!showWaitPrice">
                <img src="../../../assets/icon/option-add-circle.png" @click="addServerItem" class="a-wh-16 a-mlr-12" />
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import util from '@/utils/util'
export default {
    data () {
        return {
            util,
            options: [],
            energyFeeTypeDic: [{value:1,label:'高峰'},{value:2,label:'低谷'}]
        }
    },
    props: {
        form: {
            default: ()=>{
                return []
            }
        },
        id: {
            default: ''
        },
        showWaitPrice: {
            default: false,
        }
    },
    watch: {
        form: {
            deep:true,
            handler (val) {
                this.$emit('update:form', val);
            }
        },
        id: {
            immediate: true,
            handler (val) {
                if(val && !this.showWaitPrice) {
                    this.$nextTick(()=>{
                        this.getPlanEnergyRule()
                    })
                }
            }
        }
    },
    mounted () {
        // this.$getDic('energyFeeType', 'select').then(res=>{ this.energyFeeTypeDic = res; })
        this.options = []
        for (let index = 0; index < 24; index++) {
            if(index<10){
                this.options.push('0' + index + ':00')
            }else{
                this.options.push(index + ':00')
            }
        }
    },
    methods: {
        addServerItem () {
            this.form.push({
                startTime: '',
                endTime: '',
                energyPrice: '',
                ruleType: '',
            })
        },
        deleteServiceItem (index) {
            this.form.splice(index,1)
        },
        getPlanEnergyRule () {
            this.$Axios._get({
                url: this.$Config.apiUrl.getPlanEnergyRule,
                params: {
                    chargingPlanId: this.id
                }
            }).then(({
                data
            }) => {
                if(data && data.length) {
                    this.form.splice(0,1)
                    data.map(item=>{
                        this.form.push({
                            ...item,
                            energyPrice: this.$decimal.decimal_except(item.energyPrice, 10),
                            ruleType: item.ruleType
                        })
                    })
                }
            })
        },
    }
}
</script>

<style lang='scss' scoped>
    .form-text{
        display: block;
        width: 40px;
        min-width: 40px;
        text-align: center;
    }
    .form-text1{
        display: block;
        // width: 60px;
        min-width: 60px;
        text-align: center;
    }
    .input-size{
        width: 120px;
        min-width: 120px;
    }
</style>